import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DimDatatableColumn } from '@models';
import { MessageService } from '@services';
import { ItensServiceV2 } from '@servicesv2';
import { getDeviceType, getErrorMessage } from '@utils';
import { ModalCadastroComponent } from '../../shared/modal-cadastro/modal-cadastro.component';
import { ConsultaRapidaSaldoPorAlmoxarifadoViewModel } from 'models/itens/ConsultaRapidaItemResponseViewModel';
import { ComboboxProdutoComponent } from '../../dim-componentes/combobox-produto/combobox-produto.component';
import { ModalBasicComponent } from '../../shared/modal-basic/modal-basic.component';
import { LinhasProdutosService } from '../../services/linhas-produtos.service';
import { AlmoxarifadosService } from '../../services/almoxarifados.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-consulta-rapida-produtos',
  templateUrl: './consulta-rapida-produtos.component.html',
  styleUrls: ['./consulta-rapida-produtos.component.css']
})
export class ConsultaRapidaProdutosComponent extends ModalCadastroComponent implements OnInit {
  @ViewChild("baseModal", { static: true }) baseModal: ModalBasicComponent;
  @ViewChild("comboboxProduto", { static: true }) comboboxProduto: ComboboxProdutoComponent;
  @Input() abrirModal: any = null;
  form: FormGroup;
  dataAtual: Date = new Date();
  loading: any = {
    request: false,
  };
  tabelasPrecos: any[] = [];
  colunas: DimDatatableColumn[] = [
    { label: 'Tabela', col: 'nome', hide: false },
    { label: 'Preço', col: 'preco', format: (preco: number) => `R$ ${preco.toFixed(2)}` }
  ]
  colunasAlmoxarifados: DimDatatableColumn[] = [
    { label: 'Almoxarifado', col: 'almoxarifado', hide: false },
    { label: 'Saldo', col: 'saldo', hide: false },
  ];
  almoxarifados: ConsultaRapidaSaldoPorAlmoxarifadoViewModel[] = null;

  almoxarifadosList: any[] = [];
  linhaDeProdutoList: any[] = [];

  almoxarifadoSelecionadoId: number = null;
  linhaDeProdutoSelecionadoId: number = null;

  constructor(
    private itensService: ItensServiceV2,
    private messageService: MessageService,
    private almoxarifadoService: AlmoxarifadosService,
    private linhaDeProdutoService: LinhasProdutosService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.form = new FormGroup({
      produtoId: new FormControl(null),
      unidadeMedida: new FormControl(null),
      saldoTotal: new FormControl(null),
      precoSemTabela: new FormControl(null),
      almoxarifadoPadrao: new FormControl(null),
      linhaDeProduto: new FormControl(null),
      estoqueMinimo: new FormControl(null),
    });

    if (this.prop?.referenciaItem) {
      this.buscarItemViaReferencia(this.prop.referenciaItem);
    } else if (this.prop?.itemId) {
      this.form.get('produtoId').setValue(this.prop.itemId);
      this.produtoChanged({ id: this.prop.itemId });
    }

    this.configuracaoInicial();
  }

  public show(): void {
    this.baseModal.show();
  }

  get DeviceType() {
    return getDeviceType();
  }

  async configuracaoInicial() {
    const almoxarifadoPromise = lastValueFrom(this.almoxarifadoService.get());
    const linhaDeProdutoPromise = lastValueFrom(this.linhaDeProdutoService.get());

    const [almoxarifados, linhaDeProdutos] = await Promise.all([almoxarifadoPromise, linhaDeProdutoPromise]);
    this.almoxarifadosList = almoxarifados;
    this.linhaDeProdutoList = linhaDeProdutos;
  }

  async produtoChanged(produto: any) {
    if (!produto) {
      this.form.reset();
      this.tabelasPrecos = [];
      this.almoxarifados = [];
      return;
    }

    try {
      this.loading.request = true;
      const res = await this.itensService.consultaRapidaItem(produto.id);
      const saldoTotalCalculado = res.saldosPorAlmoxarifado?.reduce(
        (acc, cur) => acc + (Number(cur.saldo) || 0), 0) ?? 0;

      this.form.patchValue({
        unidadeMedida: res.unidadeMedida,
        precoSemTabela: res.precoSemTabela,
        saldoTotal: saldoTotalCalculado,
        almoxarifadoPadrao: res.almoxarifadoPadrao,
        linhaDeProduto: res.linhaDeProduto,
        estoqueMinimo: res.estoqueMinimo,
      });

      this.tabelasPrecos = res.tabelasPreco;
      this.almoxarifados = res.saldosPorAlmoxarifado;
    } catch (error) {
      console.error(error);
      this.messageService.error(getErrorMessage(error));
    } finally {
      this.loading.request = false;
    }
  }

  onAlmoxarifadoChange(event: any) {
    this.almoxarifadoSelecionadoId = event ? event.id : null;
    this.comboboxProduto.produtos = [];
    this.comboboxProduto.almoxarifadoId = this.almoxarifadoSelecionadoId;
    this.comboboxProduto.fetchMoreProduto('');
  }

  onLinhaDeProdutoChange(event: any) {
    this.linhaDeProdutoSelecionadoId = event ? event.id : null;
    this.comboboxProduto.produtos = [];
    this.comboboxProduto.linhaProdutoId = this.linhaDeProdutoSelecionadoId;
    this.comboboxProduto.fetchMoreProduto('');
  }

  voltar() {
    this.baseModal.hide();
  }

  async buscarItemViaReferencia(referenciaItem: string) {
    try {
      this.loading.request = true;
      const res = await this.itensService.consultarItemViaReferencia(referenciaItem);
      this.form.get('produtoId').setValue(res.id);
      this.comboboxProduto.closeSearch();
      this.produtoChanged(res);
    } catch (error) {
      console.error(error);
      this.messageService.error(getErrorMessage(error));
    } finally {
      this.loading.request = false;
    }
  }
}
